import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlineRequiredComponent } from './online-required/online-required.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    OnlineRequiredComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
  ],
  exports: [
    OnlineRequiredComponent
  ]
})
export class SoftoolsCommonModule { }
